export default __webpack_public_path__ + "static/media/icon-units-outline.7c4b3bd4.svg";